import React, { Component } from 'react';
import MdRemoveCircleOutline from 'react-icons/lib/md/remove-circle-outline';
import MdAddCircleOutline from 'react-icons/lib/md/add-circle-outline';
import debounce from 'lodash/debounce';
import './styles.css';

class Teammates extends Component {
  constructor(props){
    super(props);
    this.state = {
      teammates: this.props.teammates || [{name: '', email: ''}]
    }
  }

  componentDidMount() {
    this.triggerOnChange = debounce(this.triggerOnChange, 500);
  }
  triggerOnChange(){
    if(this.props.onChange){
      this.props.onChange.call(null, this.state.teammates);
    }
    if(this.props.isValid){
      let valid = this.validate();
      this.props.isValid.call(null, valid);
    }
  }

  validate(){
    console.log(this.state.teammates);
    let regex = /\S+@\S+\.\S+/;
    let validMails = this.state.teammates.map((mate) => {
      return regex.test(mate.email);
    }).filter((v) => {
      return !v;
    });
    console.log();
    return validMails.length === 0;
  }

  addOne(){
    let tempTeammates = this.state.teammates.slice(0);
    if(this.state.teammates.length < 5){
      tempTeammates.push({
        name: '',
        email: ''
      })
      this.setState({teammates: tempTeammates});
    }
  }
  removeOne(index){
    console.log(index, this.state.teammates[index]); // COMBAK: Remove Functionality
  }

  updateByKey(name, value, index){
    let tempTeammates = this.state.teammates.slice(0);
    let teamMate = tempTeammates[index];
    teamMate[name] = value;
    this.setState({teammates: tempTeammates});
    this.triggerOnChange();
  }

  renderLine(index){
    return (
      <div className="teammates-form-controls" key={index}>
        <div className="form-control-cell">
          <label>Name</label>
          <input value={this.state.teammates[index].name} onChange={(e) => {this.updateByKey("name", e.target.value, index)}} type="text"/>
        </div>
        <div className="form-control-cell">
          <label>Email</label>
          <input value={this.state.teammates[index].email} onChange={(e) => {this.updateByKey("email", e.target.value, index)}} type="email"/>
        </div>
        <div className="icon-cell">
          {this.state.teammates.length === (index + 1) && (
            <MdAddCircleOutline size={20} color="#ef2734" onClick={this.addOne.bind(this)} />
          )}
          {this.state.teammates.length > (index + 1) && (
            <MdRemoveCircleOutline size={20} color="#ef2734" onClick={() => {this.removeOne.call(this, index)}} />
          )}
        </div>
      </div>
    )
  }

  render(){
    return (
      <div>
        {this.state.teammates.map((item, key) => {
          return this.renderLine(key)
        })}
      </div>
    );
  }
}

export default Teammates;



// WEBPACK FOOTER //
// ./src/components/Teammates/Teammates.js